export const EmptyAuditLogList = () => <div>No items found.</div>;
